import { IMargin, IPadding } from 'src/interfaces/global';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addMarginStyles, addPaddingStyles, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

const Main = styled.main<IPadding & IMargin & { singlePage?: boolean; position?: string }>`
	${(p) => {
		return css`
			min-height: calc(100vh - 120px - 250px);

			@media (max-height: 800px) {
				padding-top: 80px;
			}

			${p.position ? `position: ${p.position};` : ''}

			${p.singlePage
				? css`
						height: 100vh;
						min-height: unset;

						${mq(
							EMediaQuery.md,
							`

							padding-top: 52px;
							height: 100vh;
					`
						)}
				  `
				: ''}

			${addPaddingStyles(p)}
			${addMarginStyles(p)}
		`;
	}}
`;

export { Main };
